<template>
  <section class="marquee">
    <div class="marquee-label">
      <span class="eyebrow">Tech Stack</span>
    </div>
    <div class="marquee-viewport">
      <div class="marquee-track">
        <span v-for="(t, i) in loopList" :key="i" class="marquee-item">{{ t }}<i></i></span>
      </div>
    </div>
  </section>
</template>

<script>
import { techStack } from '@/data/site'

export default {
  name: 'TechMarquee',
  data() {
    return { loopList: [...techStack, ...techStack] }
  }
}
</script>

<style lang="scss" scoped>
.marquee {
  position: relative;
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 26px 0;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: rgba(5, 12, 27, 0.6);
  overflow: hidden;
}

.marquee-label {
  flex-shrink: 0;
  padding-left: max(28px, calc((100vw - var(--page)) / 2 + 28px));
}

.marquee-viewport {
  flex: 1;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 88%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 88%, transparent);
}

.marquee-track {
  display: flex;
  align-items: center;
  gap: 42px;
  width: max-content;
  animation: marquee 42s linear infinite;
}

.marquee:hover .marquee-track { animation-play-state: paused; }

.marquee-item {
  display: inline-flex;
  align-items: center;
  gap: 42px;
  font-size: 15px;
  color: var(--txt-3);
  white-space: nowrap;
  letter-spacing: 0.04em;

  i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgba(34, 224, 255, 0.5);
  }
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@media (max-width: 760px) {
  .marquee { flex-direction: column; align-items: flex-start; gap: 14px; padding: 20px 0; }
  .marquee-label { padding-left: 18px; }
  .marquee-viewport { width: 100%; }
  .marquee-track { gap: 28px; }
  .marquee-item { font-size: 13.5px; gap: 28px; }
}
</style>
